<template>
  <div class="creditPanel" :style="bgStyle" @click="handleClick">
    <div class="credit">
      <span class="label">当前积分 </span>
      <span class="score">{{ credit }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    backgroundImage: {
      type: String,
      require: true
    },
    href: {
      type: String,
      require: true
    },
    moduleName: {
      type: String,
      require: true
    }
  },
  methods: {
    ...mapActions('app', {
      getRedirectUrl: function(dispatch, originUrl) {
        return dispatch(`${this.moduleName}/getRedirectUrl`, originUrl);
      }
    }),
    async handleClick() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_click',
        module_name: '积分兑奖模块',
        button_name: '兑换奖品'
      });
      const redirectUrl = await this.getRedirectUrl(this.href);
      location.href = redirectUrl;
    },
    reportExpo() {
      this.$emit('reportEvent', {
        event: 'enterprise_points_expo',
        module_name: '积分兑奖模块'
      });
    }
  },
  mounted() {
    this.reportExpo();
  },
  computed: {
    ...mapState('app', {
      credit: function(state) {
        return state[this.moduleName] && state[this.moduleName].actData
          ? state[this.moduleName].actData.credits
          : 0;
      }
    }),
    bgStyle() {
      return {
        backgroundImage: `url("${this.backgroundImage}")`
      };
    }
  }
};
</script>
<style lang="less" scoped>
.creditPanel {
  width: 100%;
  height: 442px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;

  .credit {
    margin: 102px 0 0 26px;

    .label {
      font-size: 30px;
      color: #333333;
      vertical-align: middle;
    }

    .score {
      font-size: 40px;
      color: #ff0000;
      vertical-align: middle;
    }
  }
}
</style>
